/**
 * No menu do celular, o titulo de um item com submenu SEMPRE abre e fecha o
 * acordeao — nunca leva para a colecao.
 *
 * O QUE O TEMA FAZ, E POR QUE INCOMODA
 *
 * O Empire trata o clique no titulo assim (empire.js, `_linkClicked`):
 *
 *     fechado  ->  segura o clique e ABRE o acordeao
 *     aberto   ->  deixa passar, e o navegador NAVEGA para a colecao
 *
 * Ou seja, o mesmo gesto faz duas coisas diferentes conforme o estado. Quem
 * abriu "Cowhide Rugs" para ver as tonalidades e tocou no titulo de novo
 * esperando fechar, sai da pagina — e perde o menu inteiro no caminho.
 *
 * COMO CORRIGE, E POR QUE ASSIM
 *
 * O bundle do tema e minificado e vem de fora; mexer nele custaria o proximo
 * update. Entao o clique e interceptado aqui, na fase de captura, ANTES do
 * jQuery do tema, e so no caso que falta: item ja aberto.
 *
 * Fechar nao se reimplementa — quem fecha e o proprio botao de "-" ao lado, com
 * a animacao de altura que o tema ja calcula. Este arquivo so o aciona.
 *
 * O item fechado continua com o tema: la o comportamento ja e o certo.
 */

(function () {
  var TITULO = ".navmenu-link-parent";
  var ABERTO = "navmenu-link-parent-active";
  var MENUS = ".mobile-nav-content, .mobile-nav-primary-content";

  document.addEventListener(
    "click",
    function (evento) {
      var titulo = evento.target.closest(TITULO);
      if (!titulo || !titulo.closest(MENUS)) return;

      // O titulo e filho direto do item; o mesmo seletor pega links de dentro
      // do submenu, que devem continuar navegando.
      var item = titulo.parentElement;
      if (!item || !item.hasAttribute("data-navmenu-parent")) return;

      // Fechado, o tema ja segura o clique e abre. Nada a fazer.
      if (!titulo.classList.contains(ABERTO)) return;

      var botao = item.querySelector(":scope > .navmenu-button");
      if (!botao) return;

      evento.preventDefault();

      // Sem isto o clique segue e chega ao `_linkClicked` do tema DEPOIS de o
      // botao ter fechado o acordeao. Ele olha o item, ve que esta fechado, e
      // abre de novo — fecha e reabre no mesmo gesto, e parece que o toque nao
      // fez nada. O evento morre aqui; quem age e o clique no botao, abaixo.
      evento.stopPropagation();

      botao.click();
    },
    true,
  );
})();
